import { getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackUserEvent } from '../../analytics';
import { SEMANTIC_EVENT_NAME, TOPIC_TAG_TXT, TRIGGER_OBJECT, TRIGGER_TYPE, type TriggerLocation } from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const EVENT_TEMPLATE_ID = '167';

// https://dataportal.zillowgroup.net/event-registry/7881
export const IRENE_DOWNLOAD_ATTACHMENTS_EVENT_TYPE_ID = '7881';
export const emitIreneDownloadAttachmentsEvent = (user: ZrmClickstreamUserOrNull, triggerLocation: TriggerLocation) =>
  trackUserEvent({
    envelope: {
      event_type_id: IRENE_DOWNLOAD_ATTACHMENTS_EVENT_TYPE_ID,
      event_type_version_id: '2',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'download_attachment_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.InteractMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/7882
export const IRENE_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID = '7882';
export const emitIrenePreviewAttachmentsEvent = (user: ZrmClickstreamUserOrNull, triggerLocation: TriggerLocation) =>
  trackUserEvent({
    envelope: {
      event_type_id: IRENE_PREVIEW_ATTACHMENTS_EVENT_TYPE_ID,
      event_type_version_id: '2',
      event_template_id: EVENT_TEMPLATE_ID,
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'preview_button',
      trigger_object_nm: TRIGGER_OBJECT.NoTriggerObject,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.InteractMessages,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
